/**
 * Access rules from perfis_acessos.txt.
 * Administrator can open every item. Viewer can open the client area, but not a product action.
 */

export const ROLE_LABELS = {
  admin: 'Administrador',
  manager: 'Gerente',
  common_user: 'Usuário Comum',
  viewer: 'Visualizador'
};

export const ALL_ROLES = ['admin', 'manager', 'common_user', 'viewer'];
export const CLIENT_ROLES = ['admin', 'manager', 'common_user', 'viewer'];
export const OPERATIONAL_ROLES = ['admin', 'manager', 'common_user'];
export const PARAMETER_ROLES = ['admin', 'manager'];
export const ADMIN_ROLES = ['admin'];

const PRODUCTS = [
  { key: 'casa_facil', id: 'resolve', label: 'CASA FÁCIL RESOLVE', maxpar: true },
  { key: 'casa_facil_mais', id: 'resolve-mais', label: 'CASA FÁCIL RESOLVE MAIS', maxpar: true },
  { key: 'guaibim_assist', id: 'guaibim-resolve', label: 'GUAIBIM RESOLVE', maxpar: false }
];

/**
 * Returns the product actions in the order shown in the sidebar and on the clients page.
 * GUAIBIM RESOLVE has no MAXPAR send or policy query.
 */
export function productLinks(product) {
  const uploadPath = product.maxpar
    ? `/upload?product=${product.id}`
    : '/clients/guaibim-assist';
  const links = [
    { key: 'customers', label: 'Clientes', path: `/clients/policies?product=${product.id}`, roles: OPERATIONAL_ROLES },
    { key: 'processings', label: 'Processamentos', path: `/clients/processings?product=${product.id}`, roles: OPERATIONAL_ROLES }
  ];
  if (product.maxpar) {
    links.push({
      key: 'api-sends',
      label: 'Envios API',
      path: `/api-sends?product=${product.id}`,
      roles: OPERATIONAL_ROLES
    });
  }
  links.push({
    key: 'parameters',
    label: 'Parâmetros',
    path: `/clients/billing?product=${product.id}`,
    roles: PARAMETER_ROLES
  });
  links.push({
    key: 'upload',
    label: 'Upload para Integração',
    path: uploadPath,
    roles: OPERATIONAL_ROLES
  });
  if (product.maxpar) {
    links.push({
      key: 'maxpar',
      label: 'Consulta MAXPAR',
      path: `/maxpar-query?product=${product.id}`,
      roles: OPERATIONAL_ROLES
    });
  }
  return links;
}

/**
 * Returns the Guaibim products and the links the signed-in role may open.
 */
export function clientProductsFor(role) {
  return PRODUCTS.map((product) => ({
    ...product,
    links: productLinks(product).filter((link) => link.roles.includes(role))
  })).filter((product) => product.links.length > 0);
}

/**
 * Tells whether a role may open a route group.
 */
export function roleAllowed(role, roles) {
  return role === 'admin' || (Array.isArray(roles) && roles.includes(role));
}
